import React from 'react';
import createContext from '~/src/libs/createContext';
const CHANGE_PACK_SIZE = 'change pack size';
const CHANGE_QUANTITY = 'chnage quantity';
const CHANGE_PACK_SIZE_AND_ADD_TO_CART = 'change pack size and add to cart';
const INIT = 'initialize';

const initialDeckState = {
  packSizes: [],
  packSelected: {},
};

const deckReducer = (state = initialDeckState, action) => {
  switch (action.type) {
    case INIT:
      return action.payload;
    case CHANGE_PACK_SIZE:
      return {
        ...state,
        packSelected: state?.packSizes?.find((pack) => pack?.id === action?.id),
      };
    case CHANGE_QUANTITY:
      return {
        ...state,
        packSelected: {
          ...state.packSelected,
          quantity: action.quantity,
        },
      };
    case CHANGE_PACK_SIZE_AND_ADD_TO_CART:
      const selectedPack = state?.packSizes?.find((pack) => pack?.id === action?.id);
      return {
        ...state,
        packSelected: {
          ...selectedPack,
          quantity: action.quantity,
        },
      };
  }
};

const initialize = (dispatch) => (packSizes = []) => {
  dispatch({
    type: INIT,
    payload: {
      packSizes,
      packSelected: packSizes[0],
    },
  });
};

const changePackSize = (dispatch) => (selectedPack = {}) => {
  dispatch({ type: CHANGE_PACK_SIZE, id: selectedPack?.id });
};

const changeQuantity = (dispatch) => (quantity = null) => {
  if (quantity !== null || quantity !== undefined) {
    dispatch({ type: CHANGE_QUANTITY, quantity });
  }
};

export const { Context: DeckContext, Provider: DeckProvider } = createContext(deckReducer, { changePackSize, changeQuantity, initialize }, initialDeckState);
